export const BANNER_SLOTS = {
  menu:
    [ // desktop
      'header_menu_1',
      'header_menu_2',
      'header_menu_3',
      'header_menu_4',
      'header_menu_5',
      'header_basket',
      // mobile
      'burger_main',
      'burger_woman',
      'burger_man',
      'burger_boy',
      'burger_girl',
      'burger_accessories',
      'burger_sale',
    ],
  main:
    [
      'rowbanner1_main',
      'rowbanner2_main',
      'rowbanner3_main',
      'rowbanner4_main',
      'rowbanner5_main',
      'rowbanner6_main',
      'rowbanner7_main',
      'rowbanner8_main',
      'rowbanner9_main',
      'rowbanner10_main',
      'rowbanner11_main',
    ],
};
